import store from "../../Store/configureStore";
import { strToFloat } from "../../Util/util";
import { getTotalRetrainCost } from "./retrainCalculations";
import { getProdLossWithMinBreakIn, getProdLossWithMaxBreakIn } from "./prodLossCalculations";
import { getTotalSystemCost } from "./systemCostCalculations";
const lodash = require("lodash");

export const getTotalTransitionCostMinBreakIn = () => {
  const totalRetrainCost = getTotalRetrainCost();
  const prodLoss = getProdLossWithMinBreakIn();
  const totalSystemCost = getTotalSystemCost();

  return strToFloat(totalRetrainCost) + strToFloat(prodLoss) + strToFloat(totalSystemCost);
};

export const getTotalTransitionCostMaxBreakIn = () => {
  const totalRetrainCost = getTotalRetrainCost();
  const prodLoss = getProdLossWithMaxBreakIn();
  const totalSystemCost = getTotalSystemCost();

  return strToFloat(totalRetrainCost) + strToFloat(prodLoss) + strToFloat(totalSystemCost);
};

export const getInflateAdjustedSystemCostMinBreakIn = () => {
  const state = store.getState();
  let inflationRate = lodash.get(state, "costs.costAdjustDetails.inflation-rate");
  let yearsIntoFuture = lodash.get(state, "costs.costAdjustDetails.years-into-future");
  let totalCost = getTotalTransitionCostMinBreakIn();

  if (!inflationRate || inflationRate < 0) { inflationRate = 0 }
  if (!yearsIntoFuture || yearsIntoFuture < 0) { yearsIntoFuture = 0 }
  if (!totalCost || totalCost < 0) { totalCost = 0 }

  return strToFloat(totalCost) * Math.pow(strToFloat(inflationRate) / 100 + 1, strToFloat(yearsIntoFuture));
};

export const getInflateAdjustedSystemCostMaxBreakIn = () => {
  const state = store.getState();
  let inflationRate = lodash.get(state, "costs.costAdjustDetails.inflation-rate");
  let yearsIntoFuture = lodash.get(state, "costs.costAdjustDetails.years-into-future");
  let totalCost = getTotalTransitionCostMaxBreakIn();
  
  if (!inflationRate || inflationRate < 0) { inflationRate = 0 }
  if (!yearsIntoFuture || yearsIntoFuture < 0) { yearsIntoFuture = 0 }
  if (!totalCost || totalCost < 0) { totalCost = 0 }

  return strToFloat(totalCost) * Math.pow(strToFloat(inflationRate) / 100 + 1, strToFloat(yearsIntoFuture));
};
